import {useRouter} from "next/router";
import React from "react";
import {ParsedUrlQuery} from "querystring";

export function getQueriesFromQueries(queries: ParsedUrlQuery, ...queryKeys: string[]) {
  return queryKeys.map((key) => {
    const queryItem = queries[key];
    return Array.isArray(queryItem) ? queryItem[0] : queryItem;
  });
}

export function useQueries(...queryKeys: string[]) {
  const router = useRouter();

  return React.useMemo(() => {
    return getQueriesFromQueries(router.query, ...queryKeys);
  }, [queryKeys, router.query]);
}